/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    DialogContentText,
    FormControl,
    Button,
    Select,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Typography,
    MenuItem,
} from '@material-ui/core';

import { isEmpty } from '../../../../utils/object';
import LinkOpenChat from '../../../../common/LinkOpenChat'

const ReplacementOrderV3Screens = ({ classes, reset, radioButtons, disableActionButton, reloadPage, text1, text2, text3, radioList, handleSelectValue,
    handleClickProceed, currentPage, nextPage, previousPage, handleClickBack, btnType, handleSubmit, processNextPage, setChatInitiated,
    currentSelectedRadio, isLoading, handleChangeModalState,
    replaceResponse, refundResponse, partialRefundResponse, getCurrentPage, abcGbmChatPayload, isShowingMobileChatLink }) => {
        useEffect(() => {
            getCurrentPage(currentPage, nextPage);
            if (currentPage === 'page0' && (replaceButtonCopy || dropDownOptions?.length === 0)) {
                const reason = replaceButtonCopy || buttonCopy;
                handleSelectValue({ target: { value: `${currentPage}ReasonType:${reason}` } }, reset);
            }
            if (((currentPage === 'page3' && nextPage === 'page4') || (currentPage === 'page4' && nextPage === 'page5')) && replaceButtonCopy) {
                const reason = replaceButtonCopy || buttonCopy;
                handleSelectValue({ target: { value: `${currentPage}ReasonType:${reason}` } }, reset);
            }
        }, [currentPage, nextPage]);
       
    function removeStrings(arr, stringsToRemove) {
        if (!arr) return [];
        return arr.filter(item => !stringsToRemove.includes(item));
    }

    let dropDownOptions = removeStrings(radioList, [
        'issue a full refund.',
        "No, I need additional help.",
        'Chat with a live agent now.', 
        "sounds great. Let's do it.", 
        'chat with a live agent now.',
        'redeliver the item for the requested date',
        'issue a 50% refund, and a $15 Savings Pass credit.',
    ]);
    const replaceButtonCopy = radioList?.find(item => 
        [
            'issue a full refund.',
            'redeliver the item for the requested date',
            "sounds great. let's do it.", 
            'issue a 50% refund, and a $15 savings pass credit.'
        ].includes(item.toLowerCase())
    );
    
    const additionalHelpButton = radioList?.find(item => 
        ["no, i need additional help.", 'chat with a live agent now.'].includes(item.toLowerCase())
    );

    const hasChatOption = radioList?.includes('chat with a live agent now.');
    
    let buttonCopy = btnType;
    
    if (replaceButtonCopy) buttonCopy = replaceButtonCopy;
    if (dropDownOptions?.length === 1) {
        buttonCopy = dropDownOptions[0];
        dropDownOptions = [];
    }
    if (btnType === 'Chat with agent' && additionalHelpButton !== 'chat with a live agent now.') buttonCopy = 'Chat with agent';
    
    let displayButtonCopy = buttonCopy === 'Next' ? 'Continue' : buttonCopy;
    displayButtonCopy = (btnType === 'Chat with agent' && replaceButtonCopy && additionalHelpButton === 'chat with a live agent now.') ? `${replaceButtonCopy} (Chat with agent)` : displayButtonCopy;

    const handleButtonClick = (current, next, previous, value) => {
        processNextPage({target: {value}}, current, next);
    }

    const disbaleButton = () => {
        if (replaceButtonCopy) return false;
        if (btnType === 'Chat with agent') return false;
        else return (!currentSelectedRadio && buttonCopy !== 'Continue') || isLoading;
    }
    

        return (
            <>
                
                    <div className={classes.innerContentWrapper}>
                        {!radioButtons ? <div className={classes.modalInnerContent}>
                            <DialogContentText>
                                {text1 && <div className={`${classes.modalBodyText} ${currentPage === 'page1' ? classes.modalBodySubText : ''}`}>{text1}</div>}
                                {(text2 || text3) && (
                                    <>
                                        {text2 && <p className={classes.modalBodyParagrapgh}>{text2}</p>}
                                        {text3 && <p className={classes.modalBodyParagrapgh}>{text3}</p>}
                                    </>
                                )}
                            </DialogContentText>
                            {dropDownOptions?.length > 0 && <FormControl className={classes.locationForm} role="region" aria-label="SelectIssue" variant="outlined">
                                <InputLabel 
                                    classes={{shrink: !currentSelectedRadio ? classes.InputLabelShrinkButton : classes.selectLabel}}
                                    className={`${classes.locationTypeLabel}`}
                                    htmlFor="refund-and-replacement"
                                >
                                    {['page0', 'page1'].includes(currentPage)
                                        ? currentSelectedRadio ? 'Issue*' : 'Please Select'
                                        : ['page2', 'page3', 'page4'].includes(currentPage)
                                        ? currentSelectedRadio ? 'Condition*' : 'Please Select'
                                        : 'Please Select'}
                                </InputLabel>
                                <Select
                                    className={classes.locationSelect}
                                    onChange={handleSelectValue}
                                    value={currentSelectedRadio ? `${currentPage}ReasonType:${currentSelectedRadio}` : null}
                                    id='refund-and-replacement'
                                >
                                    {dropDownOptions?.map((radio) => (
                                        <MenuItem key={radio} value={`${currentPage}ReasonType:${radio}`}>
                                            {radio.charAt(0).toUpperCase() + radio.slice(1)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>}
                        </div> : <div className={classes.modalInnerContent}>
                            <DialogContentText>
                                {text1 && <div className={classes.modalBodyText}>{text1}</div>}
                                {text2 && <div className={classes.modalBodyText}>{text2}</div>}
                                {text3 && <div className={classes.modalBodyText}>{text3}</div>}
                            </DialogContentText>
                            <FormControl>
                                <RadioGroup onChange={handleSelectValue} defaultValue={`${currentPage}ReasonType:${currentSelectedRadio}`}>
                                    {radioList?.map((radio) => (
                                        <FormControlLabel value={`${currentPage}ReasonType:${radio}`} control={<Radio color="primary" />} label={<Typography className={classes.radioButtonsPage1}>{radio}</Typography>} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>}
                        {!disableActionButton && <div className={classes.buttonsWrapper}>
                            {buttonCopy === 'Close'
                                ? (
                                    <Button
                                        className={`${classes.cancelButton} ${classes.singleCancel}`}
                                        type="button"
                                        onClick={!isEmpty(replaceResponse) || !isEmpty(refundResponse) || !isEmpty(partialRefundResponse) ? () => reloadPage() : () => handleChangeModalState('replacement', 'closeWindow', true)}
                                    >
                                        Close
                                    </Button>
                                )
                                : (
                                    <div className={classes.ctaButtonsWrapper}>
                                        <Button
                                            className={`${classes.CTAButton} ${classes.singleCTA}`}
                                            type="button"
                                            onClick={() => {
                                                if (btnType === 'Chat with agent') {
                                                    handleButtonClick(currentPage, nextPage, previousPage, `${currentPage}ReasonType:${buttonCopy}`);
                                                    setChatInitiated(true);
                                                }
                                                else if (btnType === 'Submit' ? handleSubmit(currentPage) : handleClickProceed(currentPage, nextPage));
                                            }}
                                            disabled={disbaleButton()}
                                        >
                                            {isShowingMobileChatLink && btnType === 'Chat with agent' ? <LinkOpenChat customClass={classes.mobileLink} userData={abcGbmChatPayload}>{displayButtonCopy}</LinkOpenChat> : (displayButtonCopy || 'Continue')}
                                        </Button>
                                        <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                                            {!['page0', 'page1'].includes(currentPage) &&
                                                <div
                                                    className={classes.cancelButton}
                                                    type="button"
                                                    onClick={() => handleClickBack(currentPage, previousPage, `${currentPage}ReasonType`)}
                                                >
                                                    Back
                                                </div>
                                            }
                                            {(buttonCopy !== 'Chat with agent' || additionalHelpButton === 'No, I need additional help.') && additionalHelpButton &&
                                                <div
                                                    className={classes.cancelButton}
                                                    type="button"
                                                    onClick={() => {
                                                        if (hasChatOption) {
                                                            handleSelectValue({target: {value: `${currentPage}ReasonType:${additionalHelpButton}`}}, reset);
                                                            setChatInitiated(true);
                                                        } else handleButtonClick(currentPage, nextPage, previousPage, `${currentPage}ReasonType:${additionalHelpButton}`);
                                                    }}
                                                >
                                                    {isShowingMobileChatLink && hasChatOption ? <LinkOpenChat customClass={classes.mobileLink} userData={abcGbmChatPayload}>{additionalHelpButton}</LinkOpenChat> : ((additionalHelpButton.charAt(0).toUpperCase() + additionalHelpButton.slice(1)) || 'Continue')}
                                                </div>
                                            }
                                            </div>
                                    </div>
                                )
                            }
                        </div>}
                    </div>
            </>
        )
    }

export default ReplacementOrderV3Screens;
